import { render, staticRenderFns } from "./PubSubmenu.vue?vue&type=template&id=4a2f94f6"
import script from "./PubSubmenu.vue?vue&type=script&lang=js"
export * from "./PubSubmenu.vue?vue&type=script&lang=js"
import style0 from "./PubSubmenu.vue?vue&type=style&index=0&id=4a2f94f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports